import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useGetCertificateDetailsById } from '../../../../../../hooks/api/certificates';
import { CertificateStatus } from '../../../../../../shared/interfaces/ICertificate';
import AddCompanyAccessButton from '../../../../../product-details/components/product-tab-view/tabs/permissions-tab/components/add-company-access-button/AddCompanyAccessButton';
import CertificatePermissionsTable from './components/certificate-permissions-table/CertificatePermissionsTable';
import GuidanceMessage from './components/guidance-message/GuidanceMessage';

const PermissionsTab = (): JSX.Element => {
  const { certificateId } = useParams() as { certificateId?: string };
  const { t } = useTranslation();

  const { data: certificate } = useGetCertificateDetailsById(
    { certificateId: certificateId || '' },
    {
      enabled: !!certificateId,
      retry: 0,
    },
  );

  const isCertificateExpired = certificate?.status === CertificateStatus.EXPIRED;

  return (
    <div className='flex flex-column gap-4 mt-2 md:mt-4'>
      <h4 className='m-0'>{t('certificateDetailsPage.tabs.permissionsTab.title')}</h4>
      <GuidanceMessage />
      <CertificatePermissionsTable certificateId={certificateId} />
      {certificateId && (
        <div className='flex w-auto'>
          <AddCompanyAccessButton
            certificateId={certificateId}
            disabled={isCertificateExpired}
            tooltip={
              isCertificateExpired
                ? t('certificateDetailsPage.buttons.shareCertificateDisabledTooltipText')
                : undefined
            }
            tooltipOptions={{ showOnDisabled: true, position: 'top' }}
          />
        </div>
      )}
    </div>
  );
};

export default PermissionsTab;
